export class PaymentHistoryLog {  
    customerId : string;
    transactionId : string;
    orderId : string;
    amount : number;
    total : number;
    description : string;
    paymentMethod : string;
    statusId : number;
    isActive : boolean;
    email : string;
    promoCode : string;
    invoiceNumber : string;
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/PaymentHistoryLog.ts